/* Grouped-view indent: nested cards under an app group header sit
 * 8px further in so the hierarchy reads visually. padding-left on a
 * wrapper box (not margin-left on the card itself) keeps the card's
 * `width: 100%` + box-sizing math intact so the card fills the
 * remaining content area correctly. */
.indent {
  padding-left: var(--spacing-8);
}

/* Image thumbnail inside the primitive's richMedia slot — fills
 * the slot (full width, 164px tall per the primitive) with an
 * object-fit crop so non-square Android notification pictures
 * still look intentional instead of letterboxed. */
.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Reply flow status text: rendered beneath the input row inside
 * the replySlot's own column-Box. Tiny xs-size text so it doesn't
 * compete with the reply input — matches the notification body
 * type scale. */
.replyStatus {
  font-family: var(--font-family);
  font-size: var(--text-size-xs);
  line-height: var(--text-lh-xs);
  color: var(--text-success);
}

.replyError {
  font-family: var(--font-family);
  font-size: var(--text-size-xs);
  line-height: var(--text-lh-xs);
  color: var(--text-negative);
}

/* Exit animation: the list flips `dismissing` on for ~180ms when the
 * user clicks the close button or presses E. We fade + slide right so
 * the dismiss feels physical, and disable pointer events so a stray
 * second click can't fire a second dismiss while the data round-trip
 * is still in flight. After the timeout the parent removes the data,
 * the card unmounts, and the cards below reflow up — the small
 * post-fade pop is intentional (a height-collapse transition needs a
 * known max-height the card doesn't have).
 * Shared with ConversationNotificationItem via composes. */
.dismissing {
  composes: dismissing from "../../shared/dismissing.module.css";
}

/* Public-API priority accent: a quiet left-edge stripe for high/urgent
 * server-origin notifications. min/low/default get no treatment. Applied
 * to the card via className alongside the optional `.dismissing` flag. */
.priorityHigh {
  box-shadow: inset var(--spacing-2) 0 0 0 var(--text-link);
}

.priorityUrgent {
  box-shadow: inset var(--spacing-2) 0 0 0 var(--text-negative);
}
